import React from "react";
import { Sidebar } from "@/components/ui/MultiSidebar";
import {
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/Sidebar";
import { OrganizationHeader } from "@/components/NavSidebar/OrganizationHeader";
import { NavigationLinks } from "./NavigationLinks";
import { UserMenu } from "./UserMenu";
import { navRoutes } from "@/routes";
import { useTranslation } from "react-i18next";

export function NavSidebar() {
  const { t } = useTranslation();

  return (
    <Sidebar id="nav-sidebar" sidebarId="nav" collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <OrganizationHeader />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <nav aria-label={t("nav.main")}>
          <NavigationLinks navRoutes={navRoutes} />
        </nav>
      </SidebarContent>
      <SidebarFooter>
        <nav aria-label={t("nav.user")}>
          <UserMenu />
        </nav>
      </SidebarFooter>
    </Sidebar>
  );
}
